module.exports = __webpack_public_path__ + "static/media/1.29f47824.svg";